const bedc = [
	'bedc:fpc:create',
	'bedc:fpc:create:{organizationId}/byFeatureFlag/client-fpc',
	//
	'bedc:fpc:read',
	'bedc:fpc:read:{organizationId}/byFeatureFlag/client-fpc',
	'bedc:fpc:read/measurements',
	'bedc:fpc:read/project',
	'bedc:fpc:read/customer',
	'bedc:fpc:read/debug-details',
	//
	'bedc:fpc:list',
	'bedc:fpc:list/columns/project',
	'bedc:fpc:list/columns/customer',
	'bedc:fpc:list:{organizationId}/byFeatureFlag/client-fpc',
	//
	'bedc:fpc:update',
	'bedc:fpc:update:{organizationId}/byFeatureFlag/client-fpc',
	//
	'bedc:fpc:delete',
	'bedc:fpc:delete:{organizationId}/byFeatureFlag/client-fpc',
] as const;

const integration = [
	'integration:fpc:list',
	'integration:fpc:create',
	'integration:fpc:read',
	'integration:fpc:delete',
	//
	'integration:fpc:list/variations',
] as const;

export default [...bedc, ...integration] as const;
